//@flow
import QuoteStoreClass from './quoteStoreClass';

const QuoteStore = (new QuoteStoreClass():QuoteStoreClass);
export default QuoteStore;
